<template>
  <cms-section
    v-if="content"
    class="lg:hidden"
    :section="{
      name: 'preview',
      items: [{ ...content, type: 'VfCanvasMegaMenuMobile', isFullWidth: true }],
    }"
  />
</template>

<script setup lang="ts">
defineProps<{ content: any }>()
</script>
